export default Object.assign({}, window.dnn.utility);